import React from 'react';
import { Menu, DeleteIcon, DeleteIconContainer } from './style';
import ColorDropdown from 'routes/surface/components/link-context-menu/components/color-dropdown';
import LinkStartShapeDropdown from 'routes/surface/components/link-context-menu/components/link-start-shape-dropdown';
import LinkEndShapeDropdown from 'routes/surface/components/link-context-menu/components/link-end-shape-dropdown';
import LinkLineShapeDropdown from 'routes/surface/components/link-context-menu/components/link-line-shape-dropdown';
import CopyAndLinkButton from 'routes/surface/components/link-context-menu/components/copy-reference-and-link-button';
import LinkNameInput from 'routes/surface/components/link-context-menu/components/link-name-input';
import useMutation from 'hooks/use-mutation';
import useCurrentSurfacePermissions from 'components/canvas/hooks/use-current-surface-permissions';
import useCanvas from 'components/canvas/hooks/use-canvas';
import useFindNodeInCache from 'components/canvas/hooks/use-find-node';
import { useTranslation } from 'i18n';
import { useParams } from 'react-router';
import { useNodeLinking } from 'state/canvas/node-linking';
import { useSelectedLinkOperations } from 'state/canvas/selected-link';
import { updateSurfaceNodeLinkSettingsMutation } from 'graphql/surface-node/mutations/update-surface-node-link-settings';
import { color } from 'styles/settings';
import { compose, set } from 'lodash/fp';
import {
  LineShape,
  LinkType,
  SurfaceNodePointsTo,
  SurfaceNodeUnion,
} from 'graphql/types';
import { LinkSettings, NodeRisk, Position } from 'types';
import { toast } from 'services/toast';
import { brand, linkColors, riskColors } from 'styles/settings/color';
import { useSelectedNodeOperations } from 'state/canvas/selected-node';
import { useQuery } from '@apollo/client';
import { surfaceNodeQuery } from 'graphql/surface-node/queries/surface-node';
import { updateSurfaceNodeRisk } from 'graphql/surface-node/mutations/update-surface-node-risk';
import { useRiskMenuPositionOperation } from 'state/canvas/selected-risk';
import useSaveNodeInCache from 'components/canvas/hooks/use-save-node-in-cache';

export interface RiskContextMenuProps {
  style?: any;
  position?: Position;
  scale?: number;
  onDelete?: Function;
  // link: SurfaceNodePointsTo;
  node: SurfaceNodeUnion;
  onChange?: (settings: LinkSettings) => void;
}

function RiskContextMenu({ onDelete, node, ...props }: RiskContextMenuProps) {
  const { t } = useTranslation();
  const { id } = useParams();

  const {
    canLinkSurfaceNode,
    canUnLinkSurfaceNode,
  } = useCurrentSurfacePermissions();

  // const { getSelectedNode } = useSelectedNodeOperations();

  const { clearSelectedLink } = useSelectedLinkOperations();

  const { findShapeById } = useCanvas();
  const { findReverseLink } = useFindNodeInCache();
  //TODO
  const [_, { updateLinkSettingsInCache }] = useNodeLinking(id as string);

  // const [startShape, setStartShape] = React.useState<LineShape>(
  //   link?.settings?.startShape ?? LineShape.Line,
  // );
  // const [endShape, setEndShape] = React.useState<LineShape>(
  //   link?.settings?.endShape ?? LineShape.Line,
  // );
  // const [linkType, setLinkType] = React.useState<LinkType>(
  //   link?.settings?.linkType ?? LinkType.Full,

  // );

  function updateNodePositionInCache(
    node: SurfaceNodeUnion,
    risk: string | null,
  ) {
    // }
  }

  const { getSelectedNode, setSelectedNode } = useSelectedNodeOperations();

  const { setRiskMenuPosition } = useRiskMenuPositionOperation();

  const selectedNode = getSelectedNode();

  const node2 = node;

  console.log('XXX ', props, id, selectedNode, node2);
  let color = riskColors[5];
  if (node2.risk) {
    color = riskColors[5 - parseInt(node2.risk)];
  }

  const [selectedColor, setSelectedColor] = React.useState<string>(
    color ?? brand.greenDark,
  );

  // const [linkName, setLinkName] = React.useState<string>(
  //   link?.settings?.linkName ?? '',
  // );

  // const [__, { removeConnection, addConnection, deleteLink }] = useNodeLinking(
  //   id as string,
  // );

  const [updateSurfaceNodeRiskMutation] = useMutation(updateSurfaceNodeRisk);

  const isVisible = true;
  // link.settings?.isVisible &&
  // canLinkSurfaceNode() || canUnLinkSurfaceNode(link);

  const isEditable = true; // link.settings?.isEditable;

  React.useEffect(() => {
    const settings = {
      // startShape,
      // endShape,
      // linkName,
      // linkType,
      color: selectedColor,
    };

    props.onChange && props.onChange(settings);
  }, [selectedColor]);

  const saveNodeInCache = useSaveNodeInCache();
  // const isGlobalLink =
  //   link?.from && link?.to && link?.from?.surface?.id !== link?.to?.surface?.id;

  function updateRisk(nodeId: string | null, risk: NodeRisk) {
    if (node) {
      // updateLinkSettingsInCache({ link, settings });

      // if (position) {
      const newNode = compose(
        set('risk', risk.risk),
        // set('position.y', position.y),
      )(node);

      saveNodeInCache(newNode);
      console.log('AAA NODE NEW ', newNode, node);

      updateSurfaceNodeRiskMutation({
        variables: {
          input: {
            nodeId,

            ...risk,
          },
        },
      });
    }
  }

  function onColorChange(color) {
    setSelectedColor(color);
    const isLargeNumber = (element) => element === color;
    let index = riskColors.findIndex(isLargeNumber);
    var risk: string | null = `${5 - index}`;
    if (index === 5) {
      risk = null;
    }
    console.log(' INDEX ', index, risk, color);
    updateRisk(selectedNode, { risk });
    setSelectedNode(null);
    setRiskMenuPosition(null);
  }

  // function onStartShapeChange(startShape) {
  //   const fromShape = findShapeById(link.from.id);
  //   const toShape = findShapeById(link.to.id);

  //   const isStartNodeOnTheRight = fromShape?.x() > toShape?.x();

  //   if (isStartNodeOnTheRight) {
  //     setEndShape(startShape);
  //     const reverseLink = findReverseLink(link);
  //     if (reverseLink) {
  //       updateLinkSettings(reverseLink, { startShape });
  //     }
  //   } else {
  //     setStartShape(startShape);
  //     updateLinkSettings(link, { startShape });
  //   }
  // }

  // function onEndShapeChange(endShape) {
  //   const fromShape = findShapeById(link.from.id);
  //   const toShape = findShapeById(link.to.id);

  //   const isEndNodeOnTheLeft = toShape?.x() < fromShape?.x();
  //   if (isEndNodeOnTheLeft) {
  //     setStartShape(endShape);
  //     const reverseLink = findReverseLink(link);
  //     if (reverseLink) {
  //       updateLinkSettings(reverseLink, { endShape });
  //     }
  //   } else {
  //     setEndShape(endShape);
  //     updateLinkSettings(link, { endShape });
  //   }
  // }

  // function onLinkTypeChange(linkType) {
  //   setLinkType(linkType);
  //   updateLinkSettings(link, { linkType });
  // }

  // function onLinkNameBlur(event) {
  //   const linkName = event?.target?.value;
  //   setLinkName(linkName);
  //   updateLinkSettings(link, { linkName });
  // }

  // function unLinkNodes() {
  //   if (link) {
  //     onDelete && onDelete();

  //     removeConnection(link);

  //     clearSelectedLink();

  //     return deleteLink(link).then((response) => {
  //       if (response.isSuccess) {
  //         return toast.success(t('Successfully deleted a link.'));
  //       }

  //       addConnection(link);
  //     });
  //   }
  // }

  if (isVisible && isEditable) {
    return (
      <Menu scale={props.scale} position={props.position}>
        {/* <LinkNameInput
          name="linkName"
          value={linkName}
          placeholder={t('Link name')}
          onBlur={onLinkNameBlur}
        /> */}
        <ColorDropdown
          selected={selectedColor}
          options={Object.values(riskColors)}
          onChange={onColorChange}
        />
        {/* <LinkStartShapeDropdown
          selected={startShape}
          color={selectedColor}
          onChange={onStartShapeChange}
        />
        <LinkLineShapeDropdown
          selected={linkType}
          color={selectedColor}
          onChange={onLinkTypeChange}
        />
        <LinkEndShapeDropdown
          selected={endShape}
          color={selectedColor}
          onChange={onEndShapeChange}
        />

        {isGlobalLink && <CopyAndLinkButton globalLink={link} />} */}

        {/* {canUnLinkSurfaceNode(link) && (
          <DeleteIconContainer>
            <DeleteIcon onClick={unLinkNodes} />
          </DeleteIconContainer>
        )} */}
      </Menu>
    );
  }
  return null;
}

export default RiskContextMenu;
